module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page iv. ",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2024 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("33 32 31 30 29 28 27 26 25 24     1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-38344-6 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-38358-3 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226383583.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226383583.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('i', [_vm._v("Qu’est-ce que la critique ?")]), _vm._v(" suivi de "), _c('i', [_vm._v("La culture de soi")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Édition établie par Henri-Paul Fruchaud et Daniele Lorenzini")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© Librairie Philosophique J. Vrin, Paris, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.vrin.fr",
      "target": "_blank"
    }
  }, [_vm._v("http://www.vrin.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "139",
      "src": "images/logo-CNL-new-red.jpg",
      "width": "295"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.centrenationaldulivre.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.centrenationaldulivre.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Foucault, Michel, 1926–1984, author. | Fruchaud, Henri-Paul, editor. | Lorenzini, Daniele, editor. | Davidson, Arnold I. (Arnold Ira), 1955– editor. | O’Farrell, Clare, translator. | Foucault, Michel, 1926–1984. Works. Selections (University of Chicago. Press). English.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: “What is critique?” and “The culture of the self” / Michel Foucault ; edited by Henri-Paul Fruchaud, Daniele Lorenzini, and Arnold I. Davidson ; translated by Clare O’Farrel.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Other titles: Lectures. Selections (2024). English")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : The University of Chicago Press, 2024. | Series: Chicago Foucault project | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2023016772 | ISBN 9780226383446 (cloth) | ISBN 9780226383583 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Criticism (Philosophy) | Critical theory. | Self (Philosophy)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC B2430.F722 E5 2024 | DDC 126—dc23/eng/20230424")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2023016772",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2023016772")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-912c2674","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0005.vue
// module id = 66
// module chunks = 0